import { gql } from "@apollo/client"
import { User } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

const GET_ME = gql`
  query GetMeQuery {
    me {
      id
      createdAsAccountType
      email
      unconfirmedEmail
      confirmedAt
      name
      friendlyName
      preferredName
      oysterAdmin
      skipKycVerification
      strongId
      otpStatus
      enforceMfaAfterNSignIns
      authorizations {
        actions
      }
      companiesAsAdmin {
        id
        countryCode
        equityPlan
        name
      }
      roles {
        id
        role
        termsRequired
        termsPath
        company {
          id
        }
      }
      latestKycVerification {
        id
        status
        sessionId
        sessionUrl
        updatedAt
      }
    }
  }
`

export const useMeQuery = () =>
  useQuery<{ me: User }>(GET_ME, {
    showErrorModal: false,
    ignoredErrorCodes: ["403", "429"],
  })
